export default class Header{
	constructor(){
		const header = document.querySelector('header.header');
		const toggle = header.querySelector('.header__nav__toggle');

		toggle.addEventListener("click", ()=>{
			document.body.classList.toggle("header_open");
		});
	}
}